import {
  readable
} from 'svelte/store';
import {
  orderBy,
  map,
  sumBy
} from 'lodash-es';
import {
  json
} from 'd3-fetch';

export const issueData = readable([], set => {
  json('data/4-issues.json').then(data => {
    set(orderBy(
      map(data, d => ({
        ...d,
        isInfected: sumBy(d.pages, 'infected') > 0
      })),
      'id',
      'desc',
    ));
  });
});